function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.7 22.5H10.2h10.5zm-3.15 3H10.2h7.35zm3.15-6H10.2m10.5-7.7c.9-.9 1.2-2.3.7-3.5l-2.05 2.1c-.2.2-.5.2-.7 0l-1.05-1c-.2-.2-.2-.55 0-.7l2.05-2.1c-1.15-.5-2.55-.25-3.45.7-.9.9-1.15 2.3-.65 3.5l-4.5 4.5c-.5.5-.5 1.3 0 1.8.45.45 1.25.45 1.7 0l4.5-4.55c1.2.45 2.55.2 3.45-.75zM7.7 3h16.55C25.2 3 26 3.75 26 4.75V26.8c0 1-.8 1.8-1.75 1.8H7.7c-.95 0-1.7-.8-1.7-1.8V4.75C6 3.75 6.75 3 7.7 3z",
  fill: "none",
  stroke: "currentColor"
}));